import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ shape, custom, palette }: Theme) => ({
  modalContent: {
    borderRadius: shape.borderRadius,
    backgroundColor: 'white',
    width: '100%',
    minHeight: 'min(370px, 50vh)',
    marginTop: 30,
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader: {
    width: '80px',
    height: '80px',
    transform: 'scale(2)',
    marginTop: 5,
    marginBottom: 30,
    alignSelf: 'center',
  },
  label: {
    fontFamily: 'Merriweather',
    fontSize: 24,
    fontWeight: 900,
    lineHeight: 1.33,
    textAlign: 'center',
  },
  subLabel: {
    marginTop: 15,
    fontSize: 14,
    lineHeight: 1.43,
    textAlign: 'center',
    maxWidth: 260,
    color: custom.grey[2],
  },
  submitButton: {
    marginTop: 30,
    minHeight: 50,
    fontSize: 16,
    fontWeight: 900,
    backgroundColor: `${palette.primary.main} !important`,
    color: `${palette.common.white} !important`,
    opacity: 0.3,
  },
}));
